<!--SubjectTabs: 科目列表tabs组件 2021/04/17 15:20:24 Sunanguang-->

<template>
   <div class="cm-class-tabs">
     <ul>
       <li class="cm-class-tab" v-for="(tab, i) in tabs" :key="'tab-' + i" @click="tabChange(tab)"
       :class="{'active': tab.id === selectedItem.id}" :title="tab.name" data-io-click="tracker">
          {{tab.name}}
          <span class="cm-tab-selected"></span>
      </li>
       <!-- <li v-if="items.length > 6"></li> -->
       <select-popover v-if="selectList.length > 0" class="cm-class-tabs-more" :items="selectList" :selectedItem="selectedItem"
          @select-change="selectChange"></select-popover>
     </ul>
   </div>
</template>
<script>
import SelectPopover from './SelectPopover.vue'
export default {
    name: 'ClassTabs',
    components: {
        SelectPopover
    },
    props: {
        items: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            tabs: [],
            selectList: [],
            selectedItem: {
                id: 0
            }
        }
    },
    methods: {
        tabChange: function (tab) {
            this.selectedItem = tab
            this.$store.commit('setSubjectId', tab.id)
            this.$emit('tab-change', tab)
        },
        selectChange: function (tab) {
            this.selectedItem = tab
            this.$store.commit('setSubjectId', tab.id)
            // 改变tabs、selectPopover数据
            this.changeTabsList()
            this.$emit('tab-change', tab)
        },
        changeTabsList: function () {
            this.tabs = []
            this.selectList = []
            let number = this.selectedItem.index < 9 ? 9 : 8 // 选中项是items前五项的内容，则不需要将selectedItem添加到tabs的第一位
            if (number === 8) {
                this.tabs.push(this.selectedItem)
            }
            this.items.forEach((item, i) => {
                if (i < number) {
                    this.tabs.push(item)
                } else {
                    if (number === 8 && this.selectedItem.id === item.id) {
                        // selectPopover中的选项添加到了tabs中，selectList中不再添加
                    } else {
                        this.selectList.push(item)
                    }
                }
            })
        }
    },
    watch: {
        items: {
            handler: function () {
                // 更新Dom
                this.tabs = []
                this.items.forEach((item, i) => {
                    item.index = i
                    if (i < 9) {
                        this.tabs.push(item)
                        if (i === 0) {
                            this.selectedItem = JSON.parse(JSON.stringify(item))
                            this.$store.commit('setSubjectId', item.id)
                            this.$emit('tab-change', this.selectedItem)
                        }
                    } else {
                        this.selectList.push(item)
                    }
                })
                console.log(this.tabs)
            },
            immediate: true,
            deep: true
        }
    }
}
</script>

<style scoped>
.cm-class-tabs {
  background: white;
  height: 64px;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
}

.cm-class-tabs .cm-class-tab {
  float: left;
  width: 108px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 10px;
  cursor: pointer;
  position: relative;
  font-size: 16px;
  color: #37383A;
  padding-top: 25px;
  height: 64px;
  text-align: center;
}

.cm-class-tabs .cm-class-tab:hover,
.cm-class-tabs .cm-class-tab.active {
  color: #0077FF;
}

.cm-tab-selected {
  position: absolute;
  width: 38px;
  height: 4px;
  background-color: #0077FF;
  border-radius: 2px;
  left: 50%;
  margin-left: -19px;
  bottom: 0;
  display: none;
}

.cm-class-tabs .cm-class-tab.active .cm-tab-selected {
  display: block;
}

.cm-class-tabs-more {
  float: right;
  margin: 27px 20px 0 0;
}
</style>